module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f633.9be66884.svg";